import { render, staticRenderFns } from "./PopupEdit.vue?vue&type=template&id=f49f2a48&scoped=true&"
import script from "./PopupEdit.vue?vue&type=script&lang=js&"
export * from "./PopupEdit.vue?vue&type=script&lang=js&"
import style0 from "./PopupEdit.vue?vue&type=style&index=0&id=f49f2a48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49f2a48",
  null
  
)

export default component.exports